import React from 'react';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ProductGroup } from './ILandingScopeGroup';
import { Link } from '../../components/ui/Link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface AnswerCardProps {
  productGroups: ProductGroup[];
}

const AnswerCard: React.FC<AnswerCardProps> = (props: AnswerCardProps) => {
  return props.productGroups?.map((item, index) => (
    <div
      className={`w-full pb-6 border-b-2 border-stone-100 last:border-0 mb-6`}
      key={index}
    >
      <h2 className="font-avantgarde font-bold text-lg md:text-2xl text-blue-700 mb-4">
        {item.name}
      </h2>
      <p className="mb-6">
        {item.text}
      </p>
      <div>
        <Link
          variant="primary"
          href={`/${item.slug}`}
          data-testid="bekijk"
        >
          Bekijk
          <FontAwesomeIcon icon={faChevronRight as IconProp} />
        </Link>
      </div>
    </div>
  ));
};

export default AnswerCard;
